import { Route, Routes } from "react-router-dom";
import NavBar from "./components/NavBar";
import Home from "./pages/Home";
import Footer from "./components/Footer";
import Exercise from "./pages/Exercise";
import ExerciseDetails from "./pages/ExerciseDetails";
import TrainingPrograms from "./components/TrainingPrograms";
import ChallengeFriend from "./components/ChallengeFriend";
import Pricing from "./components/Pricing";
function App() {
  return (
    <div>
      <NavBar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/home" element={<Home />} />
        <Route path="/exercise" element={<Exercise />} />
        <Route path="/exercise/:workout" element={<ExerciseDetails />} />
        {/* <Route path="/training-program" element={<TrainingPrograms />} />
        <Route path="/join-community" element={<ChallengeFriend />} />
        <Route path="/pricing" element={<Pricing />} /> */}
      </Routes>

      <Footer />
    </div>
  );
}

export default App;
